var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"epmitDetail p-t-10"},[_c('img',{attrs:{"src":_vm.epmit,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }